import {useState} from 'react'
import { motion, scale, useTransform } from "motion/react"

import iconeXP from '../../../assets/imagens/icone_XP.png'
import { MdOutlineTimer } from "react-icons/md";

import Modal from '../../Modais/IniciarChamado'

import Avatar from '../Avatar/Avatar';
import FormatTimer from '../FormatTimer';

import './Chamados.css'
export default function CardChamados({tickets}){
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [hover, setHover] = useState(false)
    
    const closeModal = () =>{
        setModalIsOpen(false)
    }

    const openModal = () =>{
        setModalIsOpen(true)

        const audio = new Audio('/sounds/popUp2.mp3')
        audio.play().catch(error => console.log('Não foi possível reproduzir o áudio: ', error))
    }

    const handleOnHover = () =>{
        setHover(true)
        const audio = new Audio('sounds/hover.mp3')
        audio.play().catch(error => console.log("Não foi possível carregar o audio: ", error))
    }

    return (
        <>
        <motion.div 
            onHoverStart={handleOnHover}
            onHoverEnd={() =>setHover(false)}

            animate={hover ? (tickets.priority === "URGENT" ? 
                        {scale:1.04,border:'1px solid var(--vermelho)', backgroundColor:"var(--fundo-vermelho)"} 
                        :{scale:1.04,  border:'1px solid var(--azul-medio)', backgroundColor:"var(--azul-escuro)"}) : ""  
                    }
                        
            transition={{
                type: "spring",
                stiffness: 300,
                damping: 15
            }}

            onClick={openModal} 
            className='containerCard'
            key={tickets.ticketId}
            >


                <motion.div
                    className="areaTopo">

                    {/* Imagem do avatar */}
                   <motion.div
                        animate={hover ? (tickets.priority === "URGENT" ? 
                                    {rotate:-5, padding: '0 5px 0 0' , border:'1px solid var(--vermelho)'} :
                                    {rotate:-5, padding: '0 5px 0 0' , border:'1px solid var(--azul-medio)'}) : "" 
                                }
                        style={{borderRadius:20, height:85}}
                    >
                        <Avatar
                            className="quadrado"
                            nome={tickets.requester}
                        />
                    </motion.div>


                    {/* Detalhes do chamado */}
                    <div className="detalhesChamado">
                        <h3>{tickets.title}</h3>
                        <p>{tickets.requester}</p>
                        
                        <motion.p
                            animate={{
                                width: hover ? "fit-content" : "12px",
                                height: hover ? "auto" : "12px",
                            }}
                            transition={{
                                duration: 0.2
                            }}
                            className={tickets.priority==="URGENT"? "tag tagUrgente": "tag tagNormal"}
                            >
                                {hover && (tickets.priority === "URGENT" ? "Urgente" : "Normal")}
                            </motion.p>
                    </div>
                </motion.div>

            <div className="areaFundo">
                <div className='flex'>
                    <img width={25} height={25} src={iconeXP} />
                    <p>{tickets.maxScore} XP</p>
                </div>
                <span>|</span>
                <div className="flex">
                    <MdOutlineTimer size={25} color="var(--cinza)" />
                    <FormatTimer sla={tickets.sla} />
                </div>
            </div>

            
        </motion.div>
        <Modal modalIsOpen={modalIsOpen} closeModal={closeModal} ticket={tickets}/>
        </>
    )
}